export default "__VITE_ASSET__BMB8Kdzn__"